import '../../App.css';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { Form, Col, Row, Modal } from 'react-bootstrap'
import { ApiContext } from '../../context/ApiContext';
import { FaPlus } from "react-icons/fa";
import { TbPencil, TbTrash } from "react-icons/tb";
import { ColumnDirective, ColumnsDirective, GridComponent, Inject, Page, Toolbar, Sort } from '@syncfusion/ej2-react-grids';
import { L10n } from '@syncfusion/ej2-base';
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { StyleContext } from '../../context/StyleContext';
import moment from 'moment';
import ModalCadastrarBSC from '../../components/modal/ModalCadastrarBSC';
import BSC from '../BSC/BSC'
import Tabela from '../../components/Tabela';

function ListaBSC() {

    const { loading, Success, Error, ListaBSCConsulta, BSCsConsulta, ListaCiclos, Ciclos, openModal, setOpenModal, setModalEditarBSC, modalEditarBSC, BSCPadrao, Permissao, ListaFiltroBSC, totalRegistrosBSC, filtroBSC, totalRegistrosFiltroBSC } = useContext(ApiContext)
    const [cicloDemandaKey, setCicloDemandaKey] = useState("")
    const { btnCriar, h3Demanda, corTerciaria } = useContext(StyleContext)
    const [BSCkey, setBSCkey] = useState("")
    const [alterar, setAlterar] = useState("")

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const editarBSC = (props) => {
        setModalEditarBSC(true)
        setBSCkey(props.key)
        setAlterar(props.cicloDemanda.naoAlterarBSCSwot)
    }

    const handleCheckboxBSCPadrao = (props) => {
        if (props.padrao) {
            return;
        }
        BSCPadrao(props.key, props.cicloDemanda.key, currentPage);
    };

    useEffect(() => {
        setModalEditarBSC(false)
        ListaCiclos()
    }, [])

    useEffect(() => {
        if (cicloDemandaKey !== "") {
            if (searchTerm.trim() !== "") {
                ListaFiltroBSC(cicloDemandaKey, searchTerm, currentPage, pageSize);
            } else {
                ListaBSCConsulta(cicloDemandaKey, currentPage, pageSize);
            }
        }
    }, [currentPage, searchTerm, cicloDemandaKey]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroBSC : totalRegistrosBSC;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <>
            <Header pagina={'BSC'}></Header>
            <MenuLateral></MenuLateral>
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            {openModal &&
                <ModalCadastrarBSC closeModal={setOpenModal} cicloDemandaKey={cicloDemandaKey} />
            }
            {modalEditarBSC &&
                <BSC BSCkey={BSCkey} naoAlterarBSCSwot={alterar} />
            }
            {!modalEditarBSC &&
                <>
                    <div className="container-pages">
                        {loading &&
                            <div className="loading-screen">
                                <div className="loader-container">
                                    <div className="spinner"></div>
                                </div>
                            </div>
                        }

                        <div style={{ display: 'flex', alignItems: 'start', justifyContent: 'space-between' }}>
                            <Col lg={3}>
                                <Form.Group className="mb-3">
                                    <Form.Select onChange={(e) => setCicloDemandaKey(e.target.value)}>
                                        <option value="0">Selecionar ciclo</option>
                                        {Ciclos?.map((item) => {
                                            return (
                                                <option key={item.id} value={item.key}>
                                                    {item.descricao}
                                                </option>
                                            )
                                        })}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            {(!!Permissao.find(item => item.menu.descricao === "BSC" && item.edicao === true)) &&
                                (cicloDemandaKey &&
                                    <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar</button>
                                )
                            }
                        </div>


                        {cicloDemandaKey ?
                            <div className='card card-bsc'>
                                <h3 className='h3-demanda' style={h3Demanda}>BSC cadastrados</h3>
                                <Tabela
                                    data={searchTerm.trim() !== "" ? filtroBSC : BSCsConsulta}
                                    columns={[
                                        {
                                            label: "BSC Padrão",
                                            width: "10%",
                                            align: "center",
                                            render: (x) => (
                                                <input
                                                    type="checkbox"
                                                    onChange={() => handleCheckboxBSCPadrao(x)}
                                                    checked={x.padrao}
                                                />
                                            ),
                                        },
                                        { label: "BSCs", field: "descricao", width: "40%" },
                                        { label: "Data de criação", field: "criacaoDataHora", width: "40%", render: (x) => moment(x.criacaoDataHora).format("DD/MM/YYYY") || "-" },
                                        { label: "Última atualização", field: "alteracaoDataHora", width: "40%", render: (x) => moment(x.alteracaoDataHora).format("DD/MM/YYYY") || "-" },
                                        {
                                            label: "Opções",
                                            width: "10%",
                                            align: "center",
                                            render: (x) => (
                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                    <button onClick={() => editarBSC(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                        <TbPencil />
                                                    </button>
                                                </div>
                                            ),
                                        },
                                    ]}
                                    loading={loading}
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    setCurrentPage={setCurrentPage}
                                    searchTerm={searchTerm}
                                    setSearchTerm={setSearchTerm}
                                    onSearch={(term) => {
                                        setCurrentPage(1);
                                        if (term.trim() !== "") {
                                            ListaFiltroBSC(cicloDemandaKey, term, 1, 10);
                                        } else {
                                            ListaBSCConsulta(cicloDemandaKey, 1, 10);
                                        }
                                    }}
                                    corTerciaria={corTerciaria}
                                />
                            </div>
                            :
                            <div style={{ marginTop: "90px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <h1 className='h1-sem-demandas'>Selecione um ciclo para o BSC</h1>
                                <h2 className='h2-sem-demandas'>Crie um novo ciclo ou contate seu supervisor.</h2>
                            </div>
                        }
                    </div>
                    <Footer></Footer>
                </>
            }
        </>
    );
}

export default ListaBSC;